import React from 'react';
import styled from 'styled-components';
import * as Constants from '../../../common/constants';
export const LinkText = (props) => {
    const { display = 'block', size = '14px', marginLeft = '0', marginRight = '0', onClick } = props;
    return (React.createElement(SLink, { onClick: onClick, style: { fontSize: size, display, marginLeft, marginRight } }, props.children));
};
const SLink = styled.p `
  color: ${Constants.COLOR.ORANGE700};
  cursor: pointer;
  font-weight: bold;
  margin: 0;
  &:hover {
    text-decoration: underline;
  }
`;
